import React, { forwardRef } from "react";
import * as t from "@rekajs/types";
import { observer } from "mobx-react-lite";
import type { ComponentType } from "@repo/editor/types";
import type { ComponentSettings } from "@repo/editor/externalComponents";
import CroppedSection from "../components/common/cropped-section";

interface TimelineProps {
  children: React.ReactNode;
}

export const TimelineComponent = forwardRef<HTMLDivElement, TimelineProps>(
  (props, ref) => {
    return (
      <>
        <div
          className="container relative pt-20 lg:pt-28 pb-20 sm:pb-0 px-4 bg-[#5E5E5E]/10"
          ref={ref}
        >
          <h2 className="md:text-4xl font-helvetica text-2xl font-normal tracking-wide mb-16 uppercase">
            Company Timeline
          </h2>

          <div className="relative flex items-center justify-between w-full md:py-44 py-32 xl:px-20 sm:px-10 px-6">
            <div className="w-10/12 h-px bg-[#636363]/80 absolute " />
            {props.children}
          </div>
        </div>
        <div className="relative  scale-[-1] -mb-[27.3%]">
          <CroppedSection fill="rgb(94 94 94 / 0.1)" />
        </div>
      </>
    );
  }
);

TimelineComponent.displayName = "TimelineComponent";

export const Timeline = observer(
  TimelineComponent
) as unknown as ComponentType<TimelineProps>;

export const timeLineSettings: ComponentSettings = {
  name: "ETimeLine",
  props: {},
  label: "تایم لاین",
  childrenAllowed: true,
  widgets: {
    label: "تایم لاین",
    template: () =>
      t.componentTemplate({
        component: t.identifier({ name: "ETimeLine", external: true }),
      }),
  },
};

Timeline.componentSettings = timeLineSettings;
